import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import { connect } from 'react-redux';
import { styled } from '@mui/material/styles';
// import { themeColors as themecolors } from '../../Reducers/Theme';
import { themecolors } from './../../Layout/theme'


const mapStateToProps = (state, ownProps) => {
  return {
    // themecolors: state.themecolors
  }
};

const CustomTextFieldRoot = styled(TextField)(({ multiline, rows }) => ({
  '& .MuiInputLabel-root': {
    marginTop: '-8px',
    fontSize: '12px',
    '&.Mui-focused': {
      color: themecolors['500'],
      marginTop: '0',
    },
    '&.Mui-error': {
      color: themecolors['error'],
    },
    '&.MuiInputLabel-shrink': {
      marginTop: '0',
    },
  },
  '& .MuiOutlinedInput-root': {
    borderRadius: '4px',
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: themecolors['500'],
    },
    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: themecolors['error'] + ' !important',
    },
  },
  '& .MuiOutlinedInput-input': {
    fontSize: multiline && rows ? '14px' : '12px' ,
    padding: '5px 14px',
    minHeight: '18px',
    height: 'auto',
    fontWeight: multiline && rows ? 400 : 'normal',
    color:multiline && rows ? 'black' : '#999'
  },
  '& .MuiOutlinedInput-multiline': {
    padding: '0',
    fontSize: '14px',
  },
  '& .MuiSelect-icon': {
    color: '#999',
  },
  '& .MuiPaper-root': {
    backgroundColor: themecolors['500'],
  },
}));

class CustomTextField extends React.Component {
  render() {
    const { classes, dispatch, ...others } = this.props;

    return (
      <CustomTextFieldRoot
        {...others}
        variant="outlined"
        margin="dense"
        InputProps={{
          ...this.props.InputProps,
        }}
        SelectProps={{
          MenuProps: {
            classes: {
              paper: 'custom-menu-paper',
            },
          },
        }}
        InputLabelProps={{
          ...this.props.InputLabelProps,
        }}
      />
    );
  }
}

CustomTextField.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(CustomTextField);
